<template>
  <div class="about">
    <h1>Edit Process</h1>
    <b-form @submit.prevent="on_submit" @reset="on_reset">
        <KnowledgeProcessForm :submit_handler="on_submit" :form="form"></KnowledgeProcessForm>
        <b-button type="submit" variant="primary" style="margin-right: 10px">Save changes</b-button>
        <b-button type="reset" variant="danger">Reset</b-button>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios';
import KnowledgeProcessForm from '@/components/KnowledgeProcessForm.vue'

export default {
  data () {
    return {
      form: {
        name: '',
        description: ''
      },
      knowledge_process: {},
      show: true
    }
  },
  methods: {
    on_submit (evt) {
      evt.preventDefault();
      this.$http.put('v1/kb/1/processes/' + this.knowledge_process.knowledge_process_id, this.form).then(response => {
          console.log(response)
          if (response.status == 200) {
              this.$router.push('/kb/1');
          }
      })
    },
    on_reset (evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.name = this.knowledge_process.name;
      this.form.description = this.knowledge_process.description;
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => { this.show = true });
    },
    fetchData() {
          this.error = this.post = null;
          this.loading = true;
          this.$http.get('v1/kb/1/processes/' + this.$route.params.knowledge_process_id + '?display=short').then(response => {
              this.knowledge_process = response.data.response.knowledge_process;
              this.loading = false;
              this.form.name = this.knowledge_process.name;
              this.form.description = this.knowledge_process.description;
          });
      }
  },
  components: {
    KnowledgeProcessForm
  },
  created () {
      this.fetchData()
  },
  watch: {
      '$route': 'fetchData'
  }
}
</script>
